import { Card } from "antd"
import { CustomBtn } from "../../../../components/commonComponents"
import Meta from "antd/es/card/Meta"

export const HierarchyCard = ({data,edit}) => {
    return(
        <Card
            style={{width: 200,minHeight:100}}
            title={data.code}
            extra={<CustomBtn label="" onClick={() => {edit(data)}} color="blue" icon={<i className="fa-solid fa-pen-to-square"></i>} colorHover={'#002E63'} />}
        >
            <Meta description={data.name} />
        </Card>
    )
}